import { Card, Button, Tag, message, Spin } from 'antd'
import { WhatsAppOutlined, ReloadOutlined } from '@ant-design/icons'
import { useState, useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import axios from 'axios'

// مسار نسبي يمر عبر Nginx (بدل الاتصال المباشر بـ localhost:3390 الذي يعمل فقط محلياً)
const WA_URL = '/wa-api'

function WhatsApp({ user }) {
  const { t } = useTranslation()
  const [status, setStatus] = useState('loading')
  const [qrCode, setQrCode] = useState(null)
  const [loading, setLoading] = useState(false)
  const intervalRef = useRef(null)

  const clientId = `client_${user?.client_id || 1}`
  const token = localStorage.getItem('token')
  const headers = { Authorization: `Bearer ${token}` }
  const hasStartedRef = useRef(false)

  useEffect(() => {
    if (hasStartedRef.current) return
    hasStartedRef.current = true

    startSession()
    return () => clearInterval(intervalRef.current)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const startSession = async () => {
    setLoading(true)
    try {
      await axios.post(`${WA_URL}/session/start`, { clientId })
      pollStatus()
    } catch (err) {
      message.error(t('whatsapp.startError'))
    }
    setLoading(false)
  }

  const stopSession = async () => {
    setLoading(true)
    try {
      await axios.post(`${WA_URL}/session/stop`, { clientId })
      setStatus('disconnected')
      setQrCode(null)
      clearInterval(intervalRef.current)
      message.success(t('whatsapp.disconnectSuccess'))
    } catch (err) {
      message.error(t('whatsapp.stopError'))
    }
    setLoading(false)
  }

  const pollStatus = () => {
    intervalRef.current = setInterval(async () => {
      try {
        const res = await axios.get(`${WA_URL}/session/qr/${clientId}`)
        setStatus(res.data.status)
        if (res.data.qr) setQrCode(res.data.qr)
        if (res.data.status === 'connected') {
          setQrCode(null)
          clearInterval(intervalRef.current)
        }
      } catch (err) {
        console.log('status fetch error')
      }
    }, 2000)
  }

  const statusTag = () => {
    const map = {
      connected:    { color: 'green',   text: t('whatsapp.statusConnected') },
      qr:           { color: 'orange',  text: t('whatsapp.statusQr') },
      connecting:   { color: 'blue',    text: t('whatsapp.statusConnecting') },
      disconnected: { color: 'red',     text: t('whatsapp.statusDisconnected') },
      loading:      { color: 'default', text: t('whatsapp.statusLoading') },
    }
    const s = map[status] || map.loading
    return <Tag color={s.color} style={{ fontSize: 14 }}>{s.text}</Tag>
  }

  return (
    <Card title={<span><WhatsAppOutlined /> {t('whatsapp.title')}</span>}>
      <div style={{ marginBottom: 16 }}>
        {t('whatsapp.statusLabel')} {statusTag()}
      </div>

      {status === 'connected' && (
        <div style={{
          background: '#f6ffed',
          border: '1px solid #b7eb8f',
          borderRadius: 8,
          padding: 24,
          textAlign: 'center',
          fontSize: 18,
          color: '#52c41a'
        }}>
          {t('whatsapp.connectedMessage')}
        </div>
      )}

      {status === 'connected' && (
        <div style={{ textAlign: 'center', marginTop: 16 }}>
          <Button
            danger
            onClick={stopSession}
            loading={loading}
          >
            {t('whatsapp.disconnectBtn')}
          </Button>
        </div>
      )}

      {status === 'qr' && qrCode && (
        <div style={{ textAlign: 'center' }}>
          <p>{t('whatsapp.qrInstructions')}</p>
          <img src={qrCode} alt="QR Code" style={{ width: 256, height: 256 }} />
        </div>
      )}

      {(status === 'connecting' || status === 'loading') && (
        <div style={{ textAlign: 'center', padding: 40 }}>
          <Spin size="large" />
          <p style={{ marginTop: 16 }}>{t('whatsapp.connectingText')}</p>
        </div>
      )}

      {status === 'disconnected' && (
        <Button
          type="primary"
          icon={<ReloadOutlined />}
          onClick={startSession}
          loading={loading}
        >
          {t('whatsapp.reconnectBtn')}
        </Button>
      )}
    </Card>
  )
}

export default WhatsApp
